<template>
  <span>{{ emoji }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      dafule: ''
    }
  },
  computed: {
    emoji () {
      return this.value === 'basket'
        ? '🏀'
        : this.value === 'volley'
          ? '🏐'
          : null
    }
  }
}
</script>
